/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */

export class Queue<T = any> {
  private items: T[] = [];

  size(): number {
    return this.items.length;
  }

  enqueue(item: T): void {
    this.items.push(item);
  }

  dequeue(): T {
    const item = this.items.shift();
    if (item === undefined) {
      throw new Error("Queue is empty");
    }
    return item;
  }

  isEmpty(): boolean {
    return this.items.length === 0;
  }
}